import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20sophisticated%20editorial%20flat%20lay%20composition%20featuring%20a%20modern%20laptop%20displaying%20colorful%20spreadsheet%20interface%20surrounded%20by%20curated%20fashion%20items%20including%20premium%20white%20sneakers%20a%20folded%20cashmere%20sweater%20and%20designer%20sunglasses%20all%20arranged%20on%20a%20warm%20cream%20marble%20surface%20with%20soft%20golden%20hour%20sunlight%20streaming%20through%20sheer%20curtains%20Scandinavian%20aesthetic%20with%20plenty%20of%20copy%20space%20clean%20and%20minimal%20composition%20high%20end%20product%20photography%20style%20neutral%20earth%20tones%20with%20subtle%20warm%20undertones%20elegant%20and%20aspirational%20atmosphere%20shot%20from%20above&width=1600&height=900&seq=kakobuy-hero-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska - modne produkty i akcesoria"
          title="Kakobuy Spreadsheet Polska - Najlepsze Znaleziska Produktowe"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm border border-background-50/30 rounded-full mb-6 md:mb-8">
          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50 font-medium tracking-wide">
            2026 • Regularnie Aktualizowane
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 md:mb-6 tracking-tight">
          Kakobuy Spreadsheet Polska
          <br />
          <span className="text-primary-400">Znajdź Najlepsze Produkty Szybciej</span>
        </h1>

        <p className="text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Kakobuy Spreadsheet to najprostszy sposób na odkrywanie popularnych produktów z Chin,
          porównywanie ofert oraz znajdowanie najlepszych okazji bez godzinnego wyszukiwania.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm md:text-base rounded-xl hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            Sprawdź Kakobuy Spreadsheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm md:text-base rounded-xl hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            Kup Teraz
            <i className="ri-shopping-cart-line ml-2"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10 md:mt-12">
          {['Aktualizowane listy produktów', 'Poradniki dla Polski', 'Bezpieczne zakupy', 'Szczegółowe porównania'].map((badge) => (
            <div key={badge} className="flex items-center gap-1.5 text-xs md:text-sm text-background-50/80">
              <i className="ri-checkbox-circle-fill text-green-400 text-sm"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}